import { createAxiosClient } from "@ntg/component-library/utilities";
import { useQuery } from "@tanstack/react-query";
import { IComparisonInfo } from "../../declarations/types";
import { IReadVerbPayload } from "../../declarations/IReadVerbPayload";

const getSalesOrderLineComparison = async (
    payload: IReadVerbPayload,
): Promise<IComparisonInfo[]> => {
    const axiosAuth = createAxiosClient("D365FO");
    const response = await axiosAuth.post<IComparisonInfo[]>(
        `/SalesOrderLine/SalesOrderLineComparisonInfoD365`,
        payload,
    );
    return response.data;
};

export const useGetSalesOrderLineComparison = (payload: IReadVerbPayload) => {
    const dataAreaId = payload.keys.dataAreaId as string;
    const inventoryLotId = payload.keys.inventoryLotId as string;
    const orderID = payload.keys.orderID as number;

    return useQuery<IComparisonInfo[]>({
        queryKey: [
            "GetSalesOrderLineComparisonInfoD365",
            {
                orderID: orderID ?? null,
                dataAreaId: dataAreaId ?? null,
                inventoryLotId: inventoryLotId ?? null,
            },
        ],
        queryFn: () => {
            if (!orderID || orderID <= 0 || !dataAreaId || !inventoryLotId) {
                throw new Error(
                    "Invalid params for GetSalesOrderLineComparisonInfoD365",
                );
            }
            return getSalesOrderLineComparison(payload);
        },
        enabled:
            Boolean(
                !orderID || orderID <= 0 || !dataAreaId || !inventoryLotId,
            ) === false,
        refetchOnWindowFocus: false,
        retry: false,
    });
};
